(function () {
  function initOne(root) {
    if (root.dataset.berndorfCuratedTabsReady === 'true') return;
    root.dataset.berndorfCuratedTabsReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-berndorf-curated-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-berndorf-curated-panel]'));
    if (!tabs.length || !panels.length) return;

    function refreshPanel(panel) {
      window.requestAnimationFrame(function () {
        panel.querySelectorAll('[data-berndorf-carousel]').forEach(function (carousel) {
          carousel.dispatchEvent(new Event('berndorf:carousel-refresh'));
        });
      });
    }

    function activate(tab, moveFocus) {
      var panelId = tab.getAttribute('aria-controls');
      tabs.forEach(function (candidate) {
        var selected = candidate === tab;
        candidate.classList.toggle('is-active', selected);
        candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
        candidate.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.id !== panelId;
      });

      var activePanel = root.querySelector('#' + panelId);
      if (activePanel) refreshPanel(activePanel);
      if (moveFocus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(tab, false);
      });
      tab.addEventListener('keydown', function (event) {
        var nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        activate(tabs[nextIndex], true);
      });
    });

    var selected = tabs.filter(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    })[0] || tabs[0];
    activate(selected, false);
  }

  function init() {
    document.querySelectorAll('[data-berndorf-curated-tabs]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
